import { render, staticRenderFns } from "./domainAvailableList.vue?vue&type=template&id=1ec48f4d&lang=pug"
import script from "./domainAvailableList.vue?vue&type=script&lang=js"
export * from "./domainAvailableList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports